import { isSameRootDomain } from './domain';

const SSO_URL = import.meta.env.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com';

function getReturnPath(returnTo?: string): string {
  if (returnTo) {
    try {
      const url = new URL(returnTo, window.location.origin);
      if (url.origin === window.location.origin) return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      // Fall through to the current location.
    }
  }
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function getSSOLoginUrl(returnTo?: string): string {
  const sameDomain = isSameRootDomain(window.location.href, SSO_URL);
  const returnPath = getReturnPath(returnTo);
  const callbackUrl = `${window.location.origin}/auth/callback?returnTo=${encodeURIComponent(returnPath)}`;
  const redirectUrl = sameDomain
    ? `${window.location.origin}${returnPath}`
    : callbackUrl;
  return `${SSO_URL}/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}`;
}

export function redirectToSSOLogin(returnTo?: string): void {
  window.location.assign(getSSOLoginUrl(returnTo));
}

export { SSO_URL };
